const isExternalPath = (path) => /^https?:\/\//.test(path || '')

export function normalizeMenuPath (path) {
  if (!path || isExternalPath(path)) return ''
  if (path === '/') return '/'
  return path.replace(/\/+$/, '')
}

function getMenuMatchScore (menu, currentPath) {
  if (!menu) return -1

  const normalizedCurrentPath = normalizeMenuPath(currentPath)
  const menuPath = normalizeMenuPath(menu.path)
  let score = -1

  if (menuPath) {
    if (normalizedCurrentPath === menuPath) {
      score = 100000 + menuPath.length
    } else if (menuPath !== '/' && normalizedCurrentPath.startsWith(menuPath + '/')) {
      score = 1000 + menuPath.length
    }
  }

  if (Array.isArray(menu.children)) {
    menu.children.forEach((child) => {
      score = Math.max(score, getMenuMatchScore(child, normalizedCurrentPath))
    })
  }

  return score
}

export function findBestTopMenu (menus = [], currentPath = '') {
  let bestMenu = null
  let bestScore = -1

  menus.forEach((menu) => {
    const score = getMenuMatchScore(menu, currentPath)
    if (score > bestScore) {
      bestScore = score
      bestMenu = menu
    }
  })

  return bestScore >= 0 ? bestMenu : null
}

export function findBestMenuPath (menus = [], currentPath = '') {
  const normalizedCurrentPath = normalizeMenuPath(currentPath)
  let bestPath = normalizedCurrentPath
  let bestScore = -1

  const visit = (items = []) => {
    items.forEach((item) => {
      const score = getMenuMatchScore(item, normalizedCurrentPath)
      const itemPath = normalizeMenuPath(item.path)
      if (itemPath && score > bestScore) {
        bestScore = score
        bestPath = itemPath
      }
      if (Array.isArray(item.children)) {
        visit(item.children)
      }
    })
  }

  visit(menus)
  return bestPath
}
